class LinkAccSessToAppHourReq {
  constructor(accSessId, appHourId, isSplit, isFirstHalf) {
    this.accountingSessionId = accSessId;
    this.appointmentHourId = appHourId;
    this.isSplit = isSplit;
    this.isFirstHalf = isFirstHalf;
  }
}

export default LinkAccSessToAppHourReq;